function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Info");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Setup-Mobile-Apps",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-809.000000, -223.000000)",
  fill: "#171717"
}, /*#__PURE__*/React.createElement("path", {
  d: "M821,223 C823.209139,223 825,224.790861 825,227 L825,235 C825,237.209139 823.209139,239 821,239 L818.554,239 L818.555,231.766 L816.332,231.766 L816.331,239 L813,239 C810.790861,239 809,237.209139 809,235 L809,227 C809,224.790861 810.790861,223 813,223 L821,223 Z M817.448,227.653 C817.256,227.653 817.0745,227.6905 816.9035,227.7655 C816.7325,227.8405 816.584,227.941 816.458,228.067 C816.332,228.193 816.2315,228.343 816.1565,228.517 C816.0815,228.691 816.044,228.877 816.044,229.075 C816.044,229.267 816.0815,229.447 816.1565,229.615 C816.2315,229.783 816.332,229.93 816.458,230.056 C816.584,230.182 816.7325,230.2825 816.9035,230.3575 C817.0745,230.4325 817.256,230.47 817.448,230.47 C817.646,230.47 817.832,230.4325 818.006,230.3575 C818.18,230.2825 818.3315,230.182 818.4605,230.056 C818.5895,229.93 818.693,229.783 818.771,229.615 C818.849,229.447 818.888,229.267 818.888,229.075 C818.888,228.877 818.849,228.691 818.771,228.517 C818.693,228.343 818.5895,228.193 818.4605,228.067 C818.3315,227.941 818.18,227.8405 818.006,227.7655 C817.832,227.6905 817.646,227.653 817.448,227.653 Z",
  id: "Combined-Shape"
})));

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.0e68c441.svg";
export { ForwardRef as ReactComponent };